export { Clipboard } from "react-native";
